import { ICON_SELECTOR, swapIcon } from '../helpers/w4d-icon.js';

(function ($) {
	class W4D_FormValidation {
		constructor() {
			this.addCustomMethods();
			this.initDefaults();
		}

		init() {
			this.initValidation();
		}

		addCustomMethods() {
			const self = this;

			// jquery-validate/src/additional/iban.js

			const parseSize = (v) => {
				if (typeof v === 'number') return v;
				const m = String(v || '')
					.trim()
					.toUpperCase()
					.match(/^([\d.]+)\s*(B|KB|MB|GB)?$/);
				if (!m) return NaN;
				const n = parseFloat(m[1]);
				const unit = m[2] || 'B';
				const mult = unit === 'GB' ? 1024 ** 3 : unit === 'MB' ? 1024 ** 2 : unit === 'KB' ? 1024 : 1;
				return Math.round(n * mult);
			};
			const filesOf = (el) => window.W4D_FileStore.get(el);

			/**
			 * IBAN is the international bank account number.
			 * It has a country - specific format, that is checked here too
			 *
			 * Validation is case-insensitive. Please make sure to normalize input yourself.
			 */
			$.validator.addMethod(
				'iban',
				function (value, element) {
					// Some quick simple tests to prevent needless work
					if (this.optional(element)) {
						return true;
					}

					// Remove spaces and to upper case
					var iban = value.replace(/ /g, '').toUpperCase(),
						ibancheckdigits = '',
						leadingZeroes = true,
						cRest = '',
						cOperator = '',
						countrycode,
						ibancheck,
						charAt,
						cChar,
						bbanpattern,
						bbancountrypatterns,
						ibanregexp,
						i,
						p;

					// Check for IBAN code length.
					// It contains:
					// country code ISO 3166-1 - two letters,
					// two check digits,
					// Basic Bank Account Number (BBAN) - up to 30 chars
					var minimalIBANlength = 5;
					if (iban.length < minimalIBANlength) {
						return false;
					}

					// Check the country code and find the country specific format
					countrycode = iban.substring(0, 2);
					bbancountrypatterns = {
						AL: '\\d{8}[\\dA-Z]{16}',
						AD: '\\d{8}[\\dA-Z]{12}',
						AT: '\\d{16}',
						AZ: '[\\dA-Z]{4}\\d{20}',
						BE: '\\d{12}',
						BH: '[A-Z]{4}[\\dA-Z]{14}',
						BA: '\\d{16}',
						BR: '\\d{23}[A-Z][\\dA-Z]',
						BG: '[A-Z]{4}\\d{6}[\\dA-Z]{8}',
						CR: '\\d{17}',
						HR: '\\d{17}',
						CY: '\\d{8}[\\dA-Z]{16}',
						CZ: '\\d{20}',
						DK: '\\d{14}',
						DO: '[A-Z]{4}\\d{20}',
						EE: '\\d{16}',
						FO: '\\d{14}',
						FI: '\\d{14}',
						FR: '\\d{10}[\\dA-Z]{11}\\d{2}',
						GE: '[\\dA-Z]{2}\\d{16}',
						DE: '\\d{18}',
						GI: '[A-Z]{4}[\\dA-Z]{15}',
						GR: '\\d{7}[\\dA-Z]{16}',
						GL: '\\d{14}',
						GT: '[\\dA-Z]{4}[\\dA-Z]{20}',
						HU: '\\d{24}',
						IS: '\\d{22}',
						IE: '[\\dA-Z]{4}\\d{14}',
						IL: '\\d{19}',
						IT: '[A-Z]\\d{10}[\\dA-Z]{12}',
						KZ: '\\d{3}[\\dA-Z]{13}',
						KW: '[A-Z]{4}[\\dA-Z]{22}',
						LV: '[A-Z]{4}[\\dA-Z]{13}',
						LB: '\\d{4}[\\dA-Z]{20}',
						LI: '\\d{5}[\\dA-Z]{12}',
						LT: '\\d{16}',
						LU: '\\d{3}[\\dA-Z]{13}',
						MK: '\\d{3}[\\dA-Z]{10}\\d{2}',
						MT: '[A-Z]{4}\\d{5}[\\dA-Z]{18}',
						MR: '\\d{23}',
						MU: '[A-Z]{4}\\d{19}[A-Z]{3}',
						MC: '\\d{10}[\\dA-Z]{11}\\d{2}',
						MD: '[\\dA-Z]{2}\\d{18}',
						ME: '\\d{18}',
						NL: '[A-Z]{4}\\d{10}',
						NO: '\\d{11}',
						PK: '[\\dA-Z]{4}\\d{16}',
						PS: '[\\dA-Z]{4}\\d{21}',
						PL: '\\d{24}',
						PT: '\\d{21}',
						RO: '[A-Z]{4}[\\dA-Z]{16}',
						SM: '[A-Z]\\d{10}[\\dA-Z]{12}',
						SA: '\\d{2}[\\dA-Z]{18}',
						RS: '\\d{18}',
						SK: '\\d{20}',
						SI: '\\d{15}',
						ES: '\\d{20}',
						SE: '\\d{20}',
						CH: '\\d{5}[\\dA-Z]{12}',
						TN: '\\d{20}',
						TR: '\\d{5}[\\dA-Z]{17}',
						AE: '\\d{3}\\d{16}',
						GB: '[A-Z]{4}\\d{14}',
						VG: '[\\dA-Z]{4}\\d{16}',
					};

					bbanpattern = bbancountrypatterns[countrycode];

					// As new countries will start using IBAN in the
					// future, we only check if the countrycode is known.
					// This prevents false negatives, while almost all
					// false positives introduced by this, will be caught
					// by the checksum validation below anyway.
					// Strict checking should return FALSE for unknown
					// countries.
					if (typeof bbanpattern !== 'undefined') {
						ibanregexp = new RegExp('^[A-Z]{2}\\d{2}' + bbanpattern + '$', '');
						if (!ibanregexp.test(iban)) {
							return false; // Invalid country specific format
						}
					}

					// Now check the checksum, first convert to digits
					ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
					for (i = 0; i < ibancheck.length; i++) {
						charAt = ibancheck.charAt(i);
						if (charAt !== '0') {
							leadingZeroes = false;
						}
						if (!leadingZeroes) {
							ibancheckdigits += '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(charAt);
						}
					}

					// Calculate the result of: ibancheckdigits % 97
					for (p = 0; p < ibancheckdigits.length; p++) {
						cChar = ibancheckdigits.charAt(p);
						cOperator = '' + cRest + '' + cChar;
						cRest = cOperator % 97;
					}
					return cRest === 1;
				},
				'Please specify a valid IBAN.'
			);

			$.validator.addMethod(
				'pattern',
				function (value, element, param) {
					if (this.optional(element)) {
						return true;
					}
					const regex = new RegExp(param);
					return regex.test(value);
				},
				'Invalid format.'
			);

			$.validator.addMethod(
				'noLeadingZero',
				function (value, element) {
					return this.optional(element) || !/^0\d+/.test(value);
				},
				'Vodeće nule nisu dozvoljene.'
			);

			$.validator.addMethod(
				'filerequired',
				function (value, el) {
					const ok = filesOf(el).length > 0;
					// Debug:
					// console.log('[filerequired]', el.name, 'count=', filesOf(el).length, 'ok=', ok);
					return ok;
				},
				'Odaberite barem jednu datoteku.'
			);

			$.validator.addMethod(
				'maxfiles',
				function (value, el, param) {
					const max = typeof param === 'string' ? parseInt(param, 10) : param;
					const ok = filesOf(el).length <= max;
					// console.log('[maxfiles]', el.name, 'count=', filesOf(el).length, 'max=', max, 'ok=', ok);
					return ok;
				},
				$.validator.format('Najviše {0} datoteka.')
			);

			$.validator.addMethod(
				'maxsizetotal',
				function (value, el, param) {
					const limit = parseSize(param);
					let total = 0;
					for (const f of filesOf(el)) {
						total += f.size;
						if (total > limit) return false;
					}
					// console.log('[maxsizetotal]', el.name, 'total=', total, 'limit=', limit, 'ok=', total <= limit);
					return true;
				},
				$.validator.format('Ukupno do {0}.')
			);

			$.validator.addMethod(
				'passwordRequirements',
				function (value, element) {
					if (!value) return false;

					const checks = self.getPasswordChecks(value);
					self.updatePasswordRequirementsUI(element, value);

					return Object.values(checks).every((v) => v === true);
				},
				''
			);

			$.validator.addMethod(
				'chipUnique',
				function (value, element) {
					const $input = $(element);
					const $field = $input.closest('[data-js="chips-field"]');
					const $hidden = $field.find('[data-js="chips-data"]');

					let existing = [];
					try {
						const raw = $hidden.val();
						existing = raw ? JSON.parse(raw) : [];
					} catch (e) {
						existing = [];
					}

					const trimmed = (value || '').trim();
					if (!trimmed) return true; // prazno ne validiramo ovdje

					// true = valid (nije duplikat), false = duplikat
					return !existing.includes(trimmed);
				},
				function (params, element) {
					const val = $(element).val().trim();
					return `Već ste unijeli vrijednost ${val}.`;
				}
			);

			$.validator.addMethod(
				'decimal',
				function (value, element) {
					if (this.optional(element)) {
						return true;
					}
					// Accept numbers with . or , as decimal separator
					return /^-?\d+([.,]\d+)?$/.test(value);
				},
				'Unesite ispravan decimalni broj.'
			);

			$.validator.addMethod(
				'greaterThan',
				function (value, element, param) {
					if (this.optional(element)) {
						return true;
					}

					const targetValue = $(param).val();

					// If target is empty, validation passes
					if (!targetValue || targetValue.trim() === '') {
						return true;
					}

					// Parse both values (handle comma separator)
					const targetNumber = parseFloat(targetValue.replace(',', '.'));
					const currentNumber = parseFloat(value.replace(',', '.'));

					// Valid if current > target (strictly greater, not equal)
					return !isNaN(targetNumber) && !isNaN(currentNumber) && currentNumber > targetNumber;
				},
				'Vrijednost mora biti veća od minimalne vrijednosti.'
			);

			// NEW: Less than validation (strict, not equal)
			$.validator.addMethod(
				'lessThan',
				function (value, element, param) {
					if (this.optional(element)) {
						return true;
					}

					const targetValue = $(param).val();

					// If target is empty, validation passes
					if (!targetValue || targetValue.trim() === '') {
						return true;
					}

					// Parse both values (handle comma separator)
					const targetNumber = parseFloat(targetValue.replace(',', '.'));
					const currentNumber = parseFloat(value.replace(',', '.'));

					// Valid if current < target (strictly less, not equal)
					return !isNaN(targetNumber) && !isNaN(currentNumber) && currentNumber < targetNumber;
				},
				'Vrijednost mora biti manja od maksimalne vrijednosti.'
			);
		}

		initDefaults() {
			const self = this;

			$.validator.setDefaults({
				validClass: 'field__input--valid', // BEM modifier for valid state
				errorClass: 'field__error-msg', // Shorter, cleaner error message class
				errorElement: 'p',
				highlight: (el) => {
					$(el)
						.addClass('field__input--error') // BEM modifier for error state
						.attr('aria-invalid', 'true');
				},
				unhighlight: (el) => {
					$(el).removeClass('field__input--error').removeAttr('aria-invalid');
				},
				errorPlacement(error, element) {
					error.attr('role', 'alert').attr('aria-live', 'polite');

					const $wrapper = element.closest('.field__input-wrapper');
					const $field = $wrapper.closest('.field');

					// Checkbox handling
					if (element.attr('name') === 'privola-checkout') return;

					if (element.attr('type') === 'checkbox') {
						const elementName = element.attr('name') || '';

						// Checkbox group (name ends with [])
						if (elementName.endsWith('[]')) {
							const $group = element.closest('.field__checkbox-group');

							if ($group.length) {
								// Remove existing errors for this group
								$group.siblings('.field__error-msg').remove();

								// Add error after the group
								error.insertAfter($group);
								return;
							}
						}
						// Single checkbox
						else {
							const $fieldLabel = element.closest('.field__label');

							if ($fieldLabel.length) {
								error.insertAfter($fieldLabel);
								return;
							}
						}
					}

					if (element.attr('class').includes('product-quantity__number')) return;

					// Handle inputs with addons

					if ($field.length && $wrapper.find('.field__addon').length) {
						error.appendTo($field);
						return;
					}

					// Default: insert after input wrapper (or element if no wrapper)
					if ($wrapper.length) {
						error.insertAfter($wrapper);
					} else {
						error.insertAfter(element);
					}
				},
				onfocusout: function (element) {
					const $el = $(element);

					if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
						this.element(element);
					}
				},
				onkeyup: function (element, event) {
					const $el = $(element);

					if ($el.attr('id') === 'new-password' || $el.attr('id') === 'confirm-password') {
						const $newPassword = $el.attr('id') === 'new-password' ? $el : $('#new-password');
						const $confirmPassword = $el.attr('id') === 'confirm-password' ? $el : $('#confirm-password');

						const passwordValue = $newPassword.val();
						const confirmValue = $confirmPassword.val();

						if (!passwordValue) return;

						// Uvijek ažuriraj UI na new-password polju
						self.updatePasswordRequirementsUI($newPassword[0], passwordValue, confirmValue);

						// ✅ Validiraj new-password ako je već bio validiran
						if ($newPassword[0].name in this.submitted || $newPassword.hasClass('field__input--error')) {
							this.element($newPassword[0]);
						}

						// Ako tipkaš u new-password i confirm ima vrijednost, validiraj confirm
						if ($el.attr('id') === 'new-password' && confirmValue) {
							this.element($confirmPassword[0]);
						}
					}

					if ($el.attr('inputmode') === 'decimal') {
						const rules = $el.rules();
						if (!rules.decimal) {
							$el.rules('add', {
								decimal: true,
							});
						}
					}

					const max = parseInt($el.data('maxlength'), 10);
					if (!isNaN(max) && max > 0) {
						// Dodaj rule samo ako već nije dodan
						const rules = $el.rules();
						if (!rules.maxlength) {
							try {
								$el.rules('add', { maxlength: max });
							} catch (err) {
								console.warn('Could not add maxlength rule:', err);
							}
						}

						// Force validation ako je length >= max (pokazati poruku odmah)
						if ($el.val().length >= max) {
							this.element(element);
						}
					}
				},
				rules: {
					iban: {
						required: true,
						iban: true,
					},
					'new-password': {
						passwordRequirements: true,
					},
					'confirm-password': {
						equalTo: '#new-password',
					},
				},
				messages: {
					iban: {
						required: 'IBAN is obavezan.',
						iban: 'IBAN je neispravan',
					},
					'confirm-password': {
						equalTo: 'Lozinke se ne podudaraju',
					},
				},

				// -------------------------------------------- WARNING --------------------------------------------

				// This will work only on the inputs with name HTML attribute set to "email"

				/*messages: {
                    email: 'Custom email message'
                }*/

				// If you want to use this for all fields with input's type attribute set to "email"
				// you need to extend the $.validator.messages hash as shown below:
				// => $.extend($.validator.messages, {});
			});

			/*
			 * Translated default messages for the jQuery validation plugin.
			 * Locale: HR (Croatia; hrvatski jezik)
			 */

			const originalMinlength = $.validator.messages.minlength;

			$.extend($.validator.messages, {
				required: 'Ovo polje je obavezno.',
				remote: 'Ovo polje treba popraviti.',
				email: 'Unesite ispravnu e-mail adresu.',
				url: 'Unesite ispravan URL.',
				date: 'Unesite ispravan datum.',
				dateISO: 'Unesite ispravan datum (ISO).',
				number: 'Unesite ispravan broj.',
				digits: 'Unesite samo brojeve.',
				creditcard: 'Unesite ispravan broj kreditne kartice.',
				equalTo: 'Unesite ponovo istu vrijednost.',
				extension: 'Unesite vrijednost sa ispravnom ekstenzijom.',
				maxlength: $.validator.format('Maksimalni broj znakova je {0} .'),
				minlength: function (param, element) {
					if ($(element).attr('type') === 'checkbox') {
						if (param === 1) {
							return 'Molimo odaberite barem jednu opciju.';
						} else {
							return `Molimo odaberite barem ${param} opcije.`;
						}
					}

					// Za text inpute - koristi original ili custom
					if (typeof originalMinlength === 'function') {
						return originalMinlength.call(this, param, element);
					} else {
						return `Minimalni broj znakova je ${param}.`;
					}
				},
				rangelength: $.validator.format('Unesite vrijednost između {0} i {1} znakova.'),
				range: $.validator.format('Unesite vrijednost između {0} i {1}.'),
				max: $.validator.format('Unesite vrijednost manju ili jednaku {0}.'),
				min: $.validator.format('Unesite vrijednost veću ili jednaku {0}.'),
				step: $.validator.format('Unesite vrijednost koja je višekratnik broja {0}.'),
			});
		}

		initValidation() {
			// Sve forme koje nemaju klasu form
			$('form:not(.form)').each(function () {
				$(this).validate();
			});

			// TODO: Unify decimal input validation on page product archive because of legeacy handling that is no longer needed due to jquery validate
			if ($('body').hasClass('archive')) {
				return;
			}
			this.initDecimalInputs();

			// Za one koje imaju je potrebno kreirati u specifičnim JS skriptama
			/*this.$form.validate({
                submitHandler: (form) => {
                    this.handleSubmit(form);
                },
            });*/
		}

		initDecimalInputs() {
			// Handle input - clean invalid characters and limit decimals
			$(document).on('input', 'input[inputmode="decimal"]', function (e) {
				const $input = $(this);
				let value = $input.val();

				// Allow typing: digits, comma, dot, minus
				value = value.replace(/[^\d.,-]/g, '');

				// Allow only one decimal separator (. or ,)
				const dotCount = (value.match(/\./g) || []).length;
				const commaCount = (value.match(/,/g) || []).length;

				if (dotCount + commaCount > 1) {
					// Keep only first separator
					let separatorFound = false;
					value = value
						.split('')
						.filter((char) => {
							if ((char === '.' || char === ',') && separatorFound) {
								return false;
							}
							if (char === '.' || char === ',') {
								separatorFound = true;
							}
							return true;
						})
						.join('');
				}

				// Limit decimal places - check both attributes
				const maxDecimals = $input.data('rule-max-decimals') || $input.data('rule-decimal-rounding');

				if (maxDecimals !== undefined) {
					// Find separator position
					const separatorIndex = Math.max(value.indexOf('.'), value.indexOf(','));

					if (separatorIndex !== -1) {
						// Split into integer and decimal parts
						const integerPart = value.substring(0, separatorIndex);
						const separator = value.charAt(separatorIndex);
						let decimalPart = value.substring(separatorIndex + 1);

						// Limit decimal part length
						if (decimalPart.length > maxDecimals) {
							decimalPart = decimalPart.substring(0, maxDecimals);
						}

						value = integerPart + separator + decimalPart;
					}
				}

				$input.val(value);
			});

			// Handle blur - format with locale and optional rounding
			$(document).on('blur', 'input[inputmode="decimal"]', function (e) {
				const $input = $(this);
				let value = $input.val().trim();

				if (!value) {
					return;
				}

				let normalized = value.replace('.', ',');

				// ONLY round if data-rule-decimal-rounding is set
				const roundingDecimals = $input.data('rule-decimal-rounding');

				if (roundingDecimals !== undefined) {
					// Parse and round
					const numberValue = parseFloat(normalized.replace(',', '.'));

					if (!isNaN(numberValue)) {
						const rounded = numberValue.toFixed(parseInt(roundingDecimals));
						normalized = rounded.replace('.', ',');
					}
				}
				// If only data-rule-max-decimals is set, no rounding on blur

				$input.val(normalized);

				// Only call .valid() if the form has a validator (to avoid TypeError)
				if ($input.closest('form').data('validator')) {
					$input.valid();
				}
			});
		}

		getPasswordChecks = (value, confirmPassword = null) => {
			if (!confirmPassword) {
				confirmPassword = $('#confirm-password').val() || '';
			}

			return {
				minLength: value.length >= 8,
				lowercase: /[a-z]/.test(value),
				uppercase: /[A-Z]/.test(value),
				number: /\d/.test(value),
				specialChar: /[@$!%*?&]/.test(value),
				passwordsMatch: confirmPassword === value,
			};
		};

		swapRequirementIcon = ($item, checked) => {
			swapIcon($item.children(ICON_SELECTOR).first(), checked ? 'check' : 'x');
		};

		updatePasswordRequirementsUI = (element, value) => {
			const checks = this.getPasswordChecks(value);
			const $requirements = $(element).closest('.field').find('.password-requirements');

			const rules = [
				{ selector: '[data-rule-min-length]', check: checks.minLength },
				{ selector: '[data-rule-min-lowercase]', check: checks.lowercase },
				{ selector: '[data-rule-min-uppercase]', check: checks.uppercase },
				{ selector: '[data-rule-min-number]', check: checks.number },
				{ selector: '[data-rule-min-special-char]', check: checks.specialChar },
				{ selector: '[data-rule-passwords-match]', check: checks.passwordsMatch },
			];

			rules.forEach(({ selector, check }) => {
				const $item = $requirements.find(selector);
				$item.toggleClass('password-requirements__item--checked', check);
				this.swapRequirementIcon($item, check);
			});
		};
	}

	const formValidation = new W4D_FormValidation();

	$(document).ready(() => {
		formValidation.init();
	});
})(jQuery);
